const {
  addDays,
  addHours,
  addMinutes,
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  differenceInSeconds,
} = window.dateFns

class CountdownTimer extends window.BAO.CustomElement() {
  static get requiredEls () {
    return ['daysitem', 'days', 'hours', 'minutes', 'seconds']
  }

  constructor () {
    super()
    this.setupListeners()
    this.hasIntervalRun = false
  }

  setupListeners () {
    this.render = this.render.bind(this)

    // Start the countdown only if the target time is in the future
    if (new Date() <= this.toDate) {
      this.timer = window.setInterval(() => {
        this.render()
        // Stop the interval when countdown reaches zero
        if (new Date() > this.toDate) {
          window.clearInterval(this.timer)
          this.renderCompleted()
        }
      }, 1000)
    } else {
      this.renderCompleted()
    }
  }

  render () {
    this.renderTime(
      this.daysUntilToDate.toString().padStart(2, '0'),
      this.hoursUntilToDate.toString().padStart(2, '0'),
      this.minutesUntilToDate.toString().padStart(2, '0'),
      this.secondsUntilToDate.toString().padStart(2, '0'),
    )

    if (!this.hasIntervalRun) {
      this.setAttribute('data-initialised', true)
      this.hasIntervalRun = true
    }
  }

  renderCompleted () {
    this.renderTime('00', '00', '00', '00')
    this.setAttribute('data-initialised', false)
  }

  renderTime (days, hours, minutes, seconds) {
    this.days.textContent = days
    this.hours.textContent = hours
    this.minutes.textContent = minutes
    this.seconds.textContent = seconds

    if (days === '00') this.daysItem.setAttribute('aria-hidden', 'true')
  }

  get daysItem () {
    return this.els.daysitem.element
  }

  get days () {
    return this.els.days.element
  }

  get hours () {
    return this.els.hours.element
  }

  get minutes () {
    return this.els.minutes.element
  }

  get seconds () {
    return this.els.seconds.element
  }

  get toDate () {
    return new Date(this.dataset.datetime)
  }

  get daysUntilToDate () {
    return differenceInDays(this.toDate, this.now)
  }

  get hoursUntilToDate () {
    return differenceInHours(
      this.toDate,
      addDays(this.now, this.daysUntilToDate),
    )
  }

  get minutesUntilToDate () {
    return differenceInMinutes(
      this.toDate,
      addDays(addHours(this.now, this.hoursUntilToDate), this.daysUntilToDate),
    )
  }

  get secondsUntilToDate () {
    return differenceInSeconds(
      this.toDate,
      addDays(
        addHours(
          addMinutes(this.now, this.minutesUntilToDate),
          this.hoursUntilToDate,
        ),
        this.daysUntilToDate,
      ),
    )
  }

  get now () {
    return Date.now()
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer)
}
